import AudioContainer from "@educaplay/core/GameProvider/GameProviderScore/Results/Result/AudioContainer";
import {
  CONTENT_TYPE,
  ImageComponent,
  TextContainer,
} from "@educaplay/core";
import clsx from "clsx";
import classes from "./resultNode.module.scss";
import listClasses from "../ResultList/resultList.module.scss";
import { Check } from "@educaplay/core/Icons/Check";
import { Wrong } from "@educaplay/core/Icons/Wrong";

function Wrapper(props) {
  const { children, isCorrect, idx, correctSingleAnswers } = props;
  return (
    <div
      className={clsx(
        classes.answer,
        isCorrect ? classes.rightAnswer : classes.wrongAnswer
      )}
    >
      <div className={classes.cardNumber}>{`${idx}`}</div>
      {children}
      {correctSingleAnswers && (
        <div className={listClasses.rightSide}>
          {isCorrect ? (
            <Check />
          ) : (
            <Wrong />
          )}
        </div>
      )}
    </div>
  );
}

export default function ResultNode({ data, idx, correctSingleAnswers }) {
  switch (data.MULTIMEDIA_TIPO) {
    case CONTENT_TYPE.AUDIO:
      return (
        <Wrapper
          isCorrect={data.correct}
          idx={idx}
          correctSingleAnswers={correctSingleAnswers}
        >
          <AudioContainer source={data.MULTIMEDIA} />
          {data.TEXT && (
            <TextContainer className={classes.text} text={data.TEXT} />
          )}
        </Wrapper>
      );
    case CONTENT_TYPE.IMAGE:
      return (
        <Wrapper
          isCorrect={data.correct}
          idx={idx}
          correctSingleAnswers={correctSingleAnswers}
        >
          <ImageComponent
            source={data.MULTIMEDIA}
            className={classes.imageComponent}
          />
          {data.TEXT && (
            <TextContainer className={classes.text} text={data.TEXT} />
          )}
        </Wrapper>
      );
    case CONTENT_TYPE.TEXT:
      return (
        <Wrapper
          isCorrect={data.correct}
          idx={idx}
          correctSingleAnswers={correctSingleAnswers}
        >
          <TextContainer className={classes.text} text={data.TEXT} />
        </Wrapper>
      );
    default:
      return <> - </>;
  }
}
